import axios from '@/libs/api.request'
import url from '@/config/url'
import axiosRequest from 'axios'
class db {
  install (Vue) {
    let db = this
    Vue.mixin({
      created: function () {
        this.$db = db
      }
    })
    this.config = url
  }
  constructor() {
    this.page = 1
    this.pageSize = 10
    this.search = []
    // this.orderBy = ''
    // this.order = ''
    this.params = []
  }

  /**
   * url 带过来的参数
   */
  setParams (params) {
    this.params = params
  }

  /**
   * 搜索条件
   * @param {[type]} search [description]
   */
  setSearch (search) {
    for (let key in search) {
      if (typeof (search[key]) === 'undefined' || search[key] === null || search[key] === "") {
        delete search[key];
      }
    }
    this.search = search
  }
  /**
   * 跳转页码
   * @param {[type]} page [description]
   */
  setPage (page) {
    this.page = page
  }
  /**
   * 设置每页显示条数
   * @param {[type]} pageSize [description]
   */
  setPageSize (pageSize) {
    this.pageSize = pageSize
  }

  /**
   * 数据列表查询
   * @param {*} url 
   */
  list (url, {
    params = {},
    search = {}
  }, isPage = true) {
    let data = {};

    let page = isPage ? {
      page: this.page,
      page_size: this.pageSize ? this.pageSize : 10
    } : {}

    Object.assign(data, params)
    Object.assign(data, search)
    Object.assign(data, page)

    for (const key in data) {
      if (!data[key] || data[key] === '') delete data[key];
    }

    return axios.request({
      url: url,
      data,
      method: 'post'
    })

  }


  /**
   * 用于vuex获取网站信息
   */
  webInfo () {

    let data = {}
    return axios.request({
      url: url.getWebInfoUrl,
      data,
      method: 'post'
    })
  }

  /**
   * 用于vuex web导航信息
   */
  webChannel () {

    let data = {}
    return axios.request({
      url: url.getChannelDataUrl,
      data,
      method: 'post'
    })
  }

  /**
   * 通用的post数据提交
   */
  post (url, params = {}) {

    let data = {}

    Object.assign(data, params);
    return axios.request({
      url: url,
      data,
      method: 'post'
    })
  }
  //文件下载
  downFilePost (url, params = {}) {
    let data = {}

    Object.assign(data, params);

    return axios.request({
      url: url,
      data,
      method: 'post',
      responseType: 'arraybuffer',
    })
  }

  /** 
   * 新增 删除 图片
   * @param Array fileList 上传成功或者删除成功的回调
   * @param String name 需要提交的对象中的哪个数组名字
   * @param Object objName 需要提交的哪个对象
   * @param Boolean remove 是否是删除
   */
  updatePicArr (fileList, name, objName, remove = false) {
    if (remove) {
      let arr = []
      fileList.forEach(item => {
        arr.push(item.response.data.id)
      })
      objName[name] = arr;
    } else {
      let index1 = fileList.length - 1; // 记录数组位置
      if (objName[name].length > 0) {
        objName[name].some((item, index) => {
          if (objName[name][index] == fileList[index1].response.data.id) {
            fileList = fileList.pop(); // 删除最后一个元素
            this.$message.error('请不要上传相同文件')
            return true // 终止循环
          }
        })
        if (fileList[index1]) {
          objName[name].push(fileList[index1].response.data.id)
        }
      } else {
        objName[name].push(fileList[index1].response.data.id)
      }
    }

  }
}

export default db;



// WEBPACK FOOTER //
// ./src/api/db.js